import { Box, Card, TopList } from '@factorialco/deprecated-design-system'

import BlankSlate from 'modules/insights/components/BlankSlate'
import ChartTooltip from 'modules/insights/components/ChartTooltip'
import TooltipLegend from 'modules/insights/components/TooltipLegend'

interface Props {
  data: { label: string; value: number }[]
  title: string
  valueTitle: string
  info: string
}

export const ListChart = ({ data, title, valueTitle, info }: Props) => (
  <Card>
    <Card.Title tooltip={info}>{title}</Card.Title>
    <Card.Content>
      {data.length == 0 && <BlankSlate />}
      {data.length > 0 && (
        <Box maxHeight="s600" width="full" overflowY="auto" flexDirection="column">
          <TopList
            leftColumnHeader={title}
            rightColumnHeader={valueTitle}
            data={data}
            tooltip={({ label, value }) => (
              <ChartTooltip title={label}>
                <TooltipLegend color="viridian1000" name={valueTitle} value={value} />
              </ChartTooltip>
            )}
          />
        </Box>
      )}
    </Card.Content>
  </Card>
)
